export default __webpack_public_path__ + "static/media/LoanBalanceBackground.2b934231.svg";